import { Trans } from 'react-i18next';

import { dispatchSnackbarWarningEvent } from '@dreryk/react-components';

import { EwusPasswordDaysUntilExpiration } from '~libs.shared.patient-entitlement-to-medical-service';

import { translationKeys } from '../translations';

import { NfzLoginLink } from './NfzLoginLink';

const getTranslationKeyByDaysUntilPasswordExpiration = (
   ewusPasswordDaysUntilExpiration: EwusPasswordDaysUntilExpiration
): string => {
   switch (ewusPasswordDaysUntilExpiration) {
      case 0:
         return translationKeys.ewusPasswordWillExpireAtTheEndOfTheDay;
      case 1:
         return translationKeys.ewusPasswordWillExpireInOneDay;
      default:
         return translationKeys.ewusPasswordWillExpireInDays;
   }
};

export const dispatchEwusPasswordDaysUntilExpirationSnackbarEvent = (
   ewusPasswordDaysUntilExpiration: EwusPasswordDaysUntilExpiration
): void => {
   return dispatchSnackbarWarningEvent(
      <Trans
         i18nKey={getTranslationKeyByDaysUntilPasswordExpiration(ewusPasswordDaysUntilExpiration)}
         values={{
            days: ewusPasswordDaysUntilExpiration,
         }}
         components={{
            link: <NfzLoginLink />,
         }}
      />,
      {
         autoHideDelayInMs: false,
      }
   );
};
